type WatchdogHandler = () => void;

const handlers = new Set<WatchdogHandler>();
let observer: MutationObserver | null = null;
let repairing = false;

const OBSERVE_OPTIONS: MutationObserverInit = {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ["style", "class", "hidden"],
};

export function registerWatermarkWatchdog(handler: WatchdogHandler) {
  handlers.add(handler);
  if (observer) return;
  observer = new MutationObserver(() => {
    if (repairing) return;
    repairing = true;
    try {
      handlers.forEach(item => item());
      observer?.takeRecords();
    } finally {
      repairing = false;
    }
  });
  observer.observe(document.body, OBSERVE_OPTIONS);
}

export function unregisterWatermarkWatchdog(handler: WatchdogHandler) {
  handlers.delete(handler);
  if (handlers.size > 0 || !observer) return;
  observer.disconnect();
  observer = null;
}

export function resetWatermarkWatchdogForTests() {
  handlers.clear();
  observer?.disconnect();
  observer = null;
  repairing = false;
}
